import { AppTitlePage } from '../../components/AppTitlePage'
import { FrozeList } from './FrozeList/FrozeList'
import { FrozeDetail } from './FrozeDetail'
import { useGetParamQuery } from '../../utils/useGetParamQuery'
import { useGetBuffetDishDetailQuery } from '../../core/api/BuffetDishApi'
import { useGetWidth } from 'utils/useGetWidth'
import { IPlanMenuControlOrdersRequest } from '../../core/api/dto/PlanMenuControlDto'

export const PlanMenuControlManagerDetail = () => {
  const dishId = useGetParamQuery('dishId')
  const startTime = useGetParamQuery('start_time')
  const endTime = useGetParamQuery('end_time')
  const { width } = useGetWidth()
  const { data: currentDish } = useGetBuffetDishDetailQuery(
    { id: Number(dishId!) },
    { skip: !dishId },
  )

  const pageParams: IPlanMenuControlOrdersRequest | null =
    startTime || endTime
      ? {
          start_time: startTime || undefined,
          end_time: endTime || undefined,
        }
      : null

  return (
    <div className="width-for-page-wrapper plan-menu-control-manager-detail">
      <AppTitlePage title={currentDish?.name || ''} goBack />
      <div className="plan-menu-control-page close manager-detail mt-15">
        <div
          className={`width-${width <= 1024 ? (width <= 768 ? 100 : 33) : 25}`}
        >
          <FrozeList pageParams={pageParams} />
        </div>
        <div
          className={`width-${width <= 1024 ? (width <= 768 ? 100 : 33) : 37}`}
        >
          <FrozeDetail withoutPhotoBlock />
        </div>
        <div
          className={`width-${width <= 1024 ? (width <= 768 ? 100 : 33) : 37}`}
        >
          <FrozeDetail withoutInfoBlock />
        </div>
      </div>
    </div>
  )
}
